import React, {useState} from 'react';
import logo from '../../public/assets/images/logo.png';
import axios from "../../axios";

let ForgetPassword = (props) => {
    const [email, setEmail] = useState("");
    const [error, setError] = useState('');

    const handleSubmit = (evt) => {
        evt.preventDefault();
        setError('')
        resetPassword()
    }

    function resetPassword() {
        // TODO change to Post request
        axios.post('forgot-password', {
            email: email
        })
            .then(function (res) {
                // handle success
                console.log("Forgot Password - Response", res);
                var Errors = res.data.errors;
                if (Errors && Errors.length > 0) {
                    setError(Errors[0])
                    console.log("Errors",Errors);
                } else {
                    if (res.data._metadata.message === "Record not found.") {
                        setError(res.data._metadata.message)
                    } else if (res.data._metadata.message === "Email Already Verified.") {
                        setError(res.data._metadata.message)
                    } else {
                        setError('Password Reset Code Sent!')
                    }
                }
            })
            .catch(function (error) {
                // handle error
                setError("Server Error")
                console.log("Resend Error", error);
            })
    }

    return (
        <>
            <div className="account-wrap reset-password">
                <div className="logo">
                    <a href="javascript:void(0)" onClick={props.goToLogin}><img src={logo} alt=""/></a>
                </div>
                <div className="container position-relative">
                    <div className="row">
                        <div className="col-sm-7 offset-sm-5">
                            <div className="account-form-wrap form-signup">
                                <div className="account-title">
                                    <h3><em>Forgot your password?</em></h3>
                                    <p><em>We’ll help you reset it and get back on track.</em></p>
                                </div>
                                <form onSubmit={handleSubmit}>
                                    <div className="form-floating no-icon">
                                        <div className="form-row">
                                            <div className="form-group col-sm-8">
                                                <label>Username or email address*</label>
                                                <input type="text" value={email}
                                                       onChange={e => setEmail(e.target.value)}
                                                       className="form-control"/>
                                                <label><span className="invalid-feedback d-block">{error}</span></label>
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <button className="btn btn-round btn-secondary">
                                                Reset Password
                                            </button>
                                        </div>
                                        <div className="form-row">
                                            <p><em><a href="javascript:void(0);" onClick={props.goToLogin}>Back</a></em>
                                            </p>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default ForgetPassword;